export default __webpack_public_path__ + "static/media/23.87424370.png";